
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Plotly } from 'vue-plotly';
import { ChartActions } from '@/store/actions/charts';
import BarChart from '@/components/DataTab/Charts/ChartComponents/BarChart.vue';
import { ChartReturnType, ScenarioNameType, ScenarioType } from '@/types';
import { txtwrapper } from '@/helpers/txtwrapper';
import { colors } from '@/assets/colors/colors';

@Component({ components: { Plotly, BarChart } })
export default class Plot19 extends Vue {
  @Prop({ type: String, required: true })
  readonly currentScenario!: ScenarioNameType;

  mounted() {
    this.$store.dispatch(ChartActions.CHART_REQUEST, {
      chartId: 19,
      basinId: 12, // all
    });
  }

  get chartData() {
    const miGap = {
      x: [] as ScenarioNameType[],
      y: [] as number[],
      name: 'Maximum M&I Gap',
      type: 'bar',
      marker: {
        // color: colors.teal,
        color: [] as string[],
      },
    };

    this.scenarioList.forEach(item => {
      miGap.marker.color.push(
        item === this.currentScenario ? colors.primary : colors.darkBlue,
      );
    });

    // const agGap = {
    //   x: [] as ScenarioNameType[],
    //   y: [] as number[],
    //   name: 'Average Ag.Gap',
    //   type: 'bar',
    //   marker: {
    //     color: colors.purple,
    //   },
    // };

    const data: ChartReturnType[] = this.$store.getters.data;
    this.scenarioList.forEach((item: string) => {
      // const agData = data.find(
      //   (obj: ChartReturnType) => obj.sector === 'AG' && obj.scenario == item,
      // );
      const miData = data.find(
        (obj: ChartReturnType) => obj.sector === 'AG' && obj.scenario == item,
      );

      // if (agData && agData.gap_average) {
      //   agGap.x.push(agData.scenario);
      //   agGap.y.push(agData.gap_average);
      // }

      if (miData && miData.gap_maximum) {
        miGap.x.push(miData.scenario);
        miGap.y.push(miData.gap_maximum);
      }
    });

    return txtwrapper([miGap]);
  }

  get scenarioList(): ScenarioNameType[] {
    const scenarios: ScenarioType[] = this.$store.getters.scenarios;
    return scenarios.map(x => x.id);
  }
}
